export default __webpack_public_path__ + "components/outside-buttons/static/logos/outside-logo--black-5add002a2b1d11f9119701589021869d.svg";